import EstablishmentApi from '../api/establishment/EstablishmentApi';
import NAICSCodesApi from '../api/naicsApi';
import * as types from './actionTypes';
import {startAjaxCall, startAjaxCallError} from './ajaxStatusActions';
import {retrieveAllForms} from './formActions';
import * as errorConstants from '../constants/errorMessages';
import {COMBINED_SUBMISSION_COMPLETED} from '../constants/EstablishmentStatusEnumeration';

export function createEstablishmentSuccessful(establishments) {
  return {type: types.CREATE_ESTABLISHMENT_SUCCESS, establishments};
}

export function loadAllEstablishmentsSuccess(establishments) {
  return {type: types.LOAD_ESTABLISHMENTS_SUCCESS, establishments};
}

export function loadSubmissionDataSuccess(submissions) {
  return {type: types.LOAD_SUBMISSION_DATA_SUCCESS, submissions};
}

export function removeEstablishmentSuccessful(establishments){
  return {type: types.REMOVE_ESTABLISHMENT_SUCCESS, establishments};
}

export function bulkRemoveEstablisjmentSuccessful(establishments) {
  return {type: types.REMOVE_ESTABLISHMENT_SUCCESS, establishments};
}

export function submitEstablishmentSuccessful(submissions){
  return {type: types.SUBMISSION_CREATED_SUCCESS, submissions};
}

export function editEstablishment(establishments) {
  return {type: types.EDIT_ESTABLISHMENT_SUCCESS, establishments};
}

export function loadStatePlanStatesSuccessful(statePlanStates) {
  return {type: types.LOAD_STATE_PLAN_STATES_SUCCESS, statePlanStates};
}

export function queryEstablishmentsWithValidationSuccess(establishments) {
  return { type: types.QUERY_ESTABLISHMENTS_WITH_VALIDATION_SUCCESS, establishments };
}

export function transferEstablishmentsSuccessful(establishments) {
  return { type: types.TRANSFER_ESTABLISHMENTS_SUCCESS, establishments };
}

export function setFrontPageFilter(filter, establishments) {
  return { type: types.SET_FRONT_PAGE_FILTER_SUCCESS, filter, establishments };
}

export function clearFrontPageFilter() {
  return { type: types.CLEAR_FRONT_PAGE_FILTER };
}

export function loadNaicsCodesSuccessful(naicsCodes) {
  return {type: types.LOAD_NAICS_CODES_SUCCESS, naicsCodes};
}

export function clearNaicsCodesDispatch() {
  return {type: types.CLEAR_NAICS_CODES};
}

export function updateEstablishmentStatus(establishments) {
  return {type: types.EDIT_ESTABLISHMENT_SUCCESS, establishments};
}

export function saveEstablishment(establishment, establishmentId) {
  const submitFunction = establishmentId ?
    EstablishmentApi.editEstablishment: EstablishmentApi.createEstablishment;
  return function(dispatch) {
    dispatch(startAjaxCall());
    return submitFunction(establishment, establishmentId)
      .then(returnedEstablishment => {
        if (returnedEstablishment.success && returnedEstablishment.results && !returnedEstablishment.results[0].errors) {
          dispatch(createEstablishmentSuccessful(returnedEstablishment.results[0]));
          return returnedEstablishment.results[0].id;
        } else {
          let error = errorConstants.ERROR_SERVER;
          if(returnedEstablishment.error) {
            error = errorConstants.ERROR_SERVER;
          } else {
           error = returnedEstablishment.results[0].errors[0];
          }
          dispatch(startAjaxCallError(error));
          throw error;
        }
      }).catch(error => {
        dispatch(startAjaxCallError(error));
        throw error;
      });
  };
}

export function removeEstablishment(establishment, establishmentId){
  return function(dispatch){
    dispatch(startAjaxCall());
    return EstablishmentApi.removeEstablishment(establishmentId, establishment.removalReason)
      .then(response => {
        if (response.success) {
          dispatch(removeEstablishmentSuccessful(
           Object.assign({},response.results[0])
          ));
        } else {
          dispatch(startAjaxCallError(response));
        }
      }).catch(error => {
        dispatch(startAjaxCallError(error));
        throw error;
      });
  };
}

export function bulkRemoveEstablishments(establishments, userEmail) {
  return function(dispatch) {
    dispatch(startAjaxCall());
    return EstablishmentApi.bulkRemoveEstablishment(establishments, userEmail)
      .then(response => {
        if (response.success) {
          dispatch(removeEstablishmentSuccessful(
            Object.assign({}, response.results)
          ));
        } else {
          dispatch(startAjaxCallError(response));
        }
      }).catch(error => {
        dispatch(startAjaxCallError(error));
        throw error;
      });
  };
}

export function restoreEstablishment(establishment, establishmentId){
  return function(dispatch) {
    dispatch(startAjaxCall());
    return EstablishmentApi.restoreEstablishment(establishment, establishmentId)
      .then(returnedEstablishment => {
        if (returnedEstablishment.success && returnedEstablishment.results && !returnedEstablishment.results[0].errors) {
          dispatch(createEstablishmentSuccessful(returnedEstablishment.results[0]));
          return returnedEstablishment.results[0].id;
        } else {
          let error = errorConstants.ERROR_SERVER;
          if(returnedEstablishment.error) {
            error = errorConstants.ERROR_SERVER;
          } else {
           error = returnedEstablishment.results[0].errors[0];
          }
          dispatch(startAjaxCallError(error));
          throw error;
        }
      }).catch(error => {
        dispatch(startAjaxCallError(error));
        throw error;
      });
  };
}
export function loadAllEstablishments() {
  return function(dispatch) {
    dispatch(startAjaxCall());
    return EstablishmentApi.getAllEstablishments()
      .then(response => {
        if (response.success){
          const sortedResults = sortEstablishments(response.results);
          dispatch(loadAllEstablishmentsSuccess(sortedResults));
        } else {
          dispatch(startAjaxCallError(response));
        }
      }).catch(error => {
        dispatch(startAjaxCallError(error));
        throw error;
      });
  };
}

export function retrieveEstablishmentForm() {
  return function (dispatch) {
    return dispatch(retrieveAllForms());
  };
}

export function submitEstablishments(establishments){
  return function(dispatch){
    dispatch(startAjaxCall());
    return EstablishmentApi.submitEstablishmentsCombined(establishments)
      .then(response=>{
        if(response.success){
          response.results.map(
            result => {
              dispatch(submitEstablishmentSuccessful(result));
              dispatch(editEstablishment(result.establishment));
              dispatch(updateEstablishmentStatus(Object.assign({}, result.establishment, {combined_submission_status: COMBINED_SUBMISSION_COMPLETED})));
            });
          return response;
        } else {
          dispatch(startAjaxCallError(response));
        }
      }).catch(error => {
        dispatch(startAjaxCallError(error));
        throw error;
      });
  };
}

export function queryEstablishmentsWithValidation(data) {
  return function(dispatch) {
    dispatch(startAjaxCall());
    return EstablishmentApi.queryEstablishmentsWithValidation(data)
      .then(response => {
        if (response.success) {
          dispatch(queryEstablishmentsWithValidationSuccess(response.results));
          return response;
        } else {
          dispatch(startAjaxCallError(response.error));
          return response;
        }
      })
      .catch(error => {
        dispatch(startAjaxCallError(error));
        throw error;
      });
  };
}

export function transferEstablishments(data) {
  return function(dispatch) {
    dispatch(startAjaxCall());
    return EstablishmentApi.transferEstablishments(data)
      .then(response => {
        if (response.success) {
          dispatch(transferEstablishmentsSuccessful(response.results));
          return response;
        } else {
          dispatch(startAjaxCallError(response.error));
          return response;
        }
      })
      .catch(error => {
        dispatch(startAjaxCallError(error));
        throw error;
      });
  };
}


export function loadSubmissionData(link) {
  return function(dispatch) {
    dispatch(startAjaxCall());
    return EstablishmentApi
      .getSubmissionData(link)
      .then(returnedSubmission => {
        dispatch(loadSubmissionDataSuccess(returnedSubmission.results[0]));
        return returnedSubmission.results[0];
      }).catch(error => {
        startAjaxCallError(error);
        throw error;
      });
  };
}

export function loadStatePlanStates() {
  return function (dispatch) {
    dispatch(startAjaxCall());
    return EstablishmentApi.getStatePlanStates().then(response => {
      dispatch(loadStatePlanStatesSuccessful(response));
    }).catch(error => {
      startAjaxCallError(error);
      throw error;
    });
  };
}

export function loadNaicsCodes(input) {
  return function (dispatch) {
    return NAICSCodesApi.getNaicsCodes(input).then(response => {
      dispatch(loadNaicsCodesSuccessful(response));
      return response;
    }).catch(error => {
      startAjaxCallError(error);
      throw error;
    });
  };
}

export function clearNaicsCodes() {
  return function (dispatch) {
    dispatch(clearNaicsCodesDispatch());
  };
}

function sortEstablishments(establishments) {
  return establishments.sort(sortByTime);
}

function sortByTime(establishmentA, establishmentB){
  const establishmentATime = establishmentA.last_edited_timestamp || establishmentA.created_timestamp;
  const establishmentBTime = establishmentB.last_edited_timestamp || establishmentB.created_timmestamp;

  if(establishmentATime < establishmentBTime) {
    return 1;
  } else if (establishmentATime > establishmentBTime) {
    return -1;
  } else {
    return 0;
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/establishmentActions.js
 **/